export default __webpack_public_path__ + "static/media/8942.653b4065.svg";